import { buildChartRows } from './__fixtures__/discoverFixtures';
// Uncomment along with the request below.
// import store from '@/store';
// import { POST_METHOD, Request } from '@/lib/http';
// import AuthEnum from '../lib/enums/auth-enum';

// DiscoverService
//
// Discover-only server data: the bar-chart metric data. (Medication search is
// client-side over the prefetched `allMedications` list, so it needs no service
// method — see MedicationSearch.vue.)
//
// TEMPORARY: `/chart-data` does not exist yet, so `getChartData` resolves
// generated placeholder rows in the endpoint's documented response shape. The
// real call is commented below — swapping is: uncomment the request plus the
// imports above, delete the fixture return and its import. See
// DISCOVER_DATA_CONTRACTS.md §8, which also specifies the four aggregations the
// endpoint must own.
//
// Endpoint is tenant-scoped, matching every other tenant service here: the
// blueprint mounts at `/api/formulary`, the tenant id is the first path segment,
// and `authType: AuthEnum.TENANT` sends the tenant token. On the Flask side
// `@auth.tenant_route` prefixes `/<tenant_id>` and validates it against the
// token, so the tenant is an implicit filter on top of the `filters` payload.

// Uncomment along with the request below.
// const baseURL = '/api/formulary';

export default {
  // Chart data for ALL selected metrics in ONE request.
  // -> { results: [{ name, metrics: { <metric>: number } }] }
  //
  // ONE CALL, NOT ONE PER METRIC. The four metrics are aggregations over the
  // same filtered row set grouped by the same key (medication + formulation),
  // so a per-metric fan-out re-ran that scan and its HAVING clause once per
  // selected metric and then pivoted the results back together in the browser.
  // Sending the whole metric list lets the backend compute them as additional
  // aggregate columns in a single pass and return them already pivoted.
  //
  // `metrics` is ordered by the user's selection: the backend sorts by them in
  // that order (descending, ties broken by name) and returns at most `limit`
  // rows, so the top-N happens in SQL rather than over a full-catalog payload.
  // The first metric is therefore the primary sort key, matching what the chart
  // draws as its leading bar.
  //
  // POST, not GET: the filter payload carries inclusion/exclusion arrays that
  // can hold hundreds of medication names, and `generateQueryParamsString`
  // JSON-encodes each value into the query string — long enough to risk URL
  // length limits and awkward to read in logs. services/identity.js is the
  // precedent for a tenant-scoped POST with a JSON body.
  getChartData({ metrics, filters, limit }) {
    // const tenantId = store.getters.tenant.id;
    // const request = new Request(`${baseURL}/${tenantId}/chart-data`, {
    //   body: { metrics, filters, limit },
    //   method: POST_METHOD,
    //   authType: AuthEnum.TENANT,
    // });
    // return request.send();
    return Promise.resolve({ results: buildChartRows(metrics, filters, limit) });
  },
};
